import { useEffect, useRef, useState } from "react"
import conf from "../../../conf/conf";
import axios from "../../../utils/axios";
import * as apiFN from "../../../api/apiFileNavigator";
import { useFileNavigator } from "../../../context/FileNavigator";
import { useToast } from "../../../context/ToastContext";
import { useTranslation } from "react-i18next";

const UploadFile = ({targetOpen,setProgress}) => {

    const refInputFile  = useRef(null);
    const prevOpen      = useRef();
    const { t } = useTranslation(['FileNavigator']);
    const { stateFN, dispatchFN, fetchDataFN } = useFileNavigator();

    const { showToast } = useToast();


    const handleChangeFile = async () => {
        const files = refInputFile.current.files;   
        const uploadData = {
            files               : files,
            currentPath         : stateFN.currentPathFN,
            onUploadProgress    : handleUploadProgress
        } 

        dispatchFN({type:'SET_DATA_FN', payload:null});

        // Завантаження фалйыв на сервер
        const resUpload = await apiFN.uploadFiles(uploadData);
        (resUpload)
            ? showToast(t('messDownloadSuccess'), 'success')
            : showToast(t('common:messError'), 'danger');

        fetchDataFN(true);
        setProgress(0); // Скидаємо прогрес після завантаження
  
    }
 
    const handleUploadProgress =  (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setProgress(percentCompleted); // Оновлюємо прогрес
    }

    // Хук відслідковування атргету відкриття діалогу
    useEffect(()=>{
        if ((prevOpen.current !== undefined) && (prevOpen.current !== targetOpen)) {
            refInputFile.current.value = null;
            refInputFile.current.click();
        }
        prevOpen.current = targetOpen;
    }, [targetOpen])

    return (
        <>
        <input type="file"
            ref={refInputFile}
            onChange={handleChangeFile}
            className="d-none"
            multiple/>
        </>
    )
}

export default UploadFile;